export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13991.b8dd64d0.jpg";